import { API } from "./utils"


export const shares = {
  sharesCreate: (data) => API.post("/shares/", data),
  sharesRetrieve: (id) => API.get(`/shares/${id}/`),
  sharesUpdate: (id, data) => API.put(`/shares/${id}/`, data),
  sharesDelete: (id) => API.delete(`/shares/${id}/`),
}
